import { editorInstance } from './EditorStore';

export const updateEditorInstance = (value) => editorInstance.update(oldValue => value);
